import { render, staticRenderFns } from "./RegistroDeSaques.vue?vue&type=template&id=67086fa9&scoped=true"
import script from "./RegistroDeSaques.vue?vue&type=script&lang=js"
export * from "./RegistroDeSaques.vue?vue&type=script&lang=js"
import style0 from "./RegistroDeSaques.vue?vue&type=style&index=0&id=67086fa9&prod&lang=css"
import style1 from "./RegistroDeSaques.vue?vue&type=style&index=1&id=67086fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67086fa9",
  null
  
)

export default component.exports